// extracted by mini-css-extract-plugin
export default {"pageTitle":"schedule_pageTitle__qbkC9","schedule":"schedule_schedule__HhRMX","box":"schedule_box__DhMF3","empty":"schedule_empty__Ogj3e"};